export function waitForEvent(el: HTMLElement, eventName: string, timeout = 5000) {
  return new Promise<void>(resolve => {
    const timer = setTimeout(() => {
      el.removeEventListener(eventName, done)
      resolve()
    }, timeout)

    function done(event: Event) {
      if (event.target === el) {
        clearTimeout(timer)
        el.removeEventListener(eventName, done)
        resolve()
      }
    }

    el.addEventListener(eventName, done)
  })
}
